export default __webpack_public_path__ + "static/media/pantai1.538cdc67.jpg";